var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.classic
    ? _c(
        "div",
        { staticClass: "pa-2 text-center si-sta-facendo-asta-per" },
        [
          _c("span", [_vm._v("Si sta facendo asta per ")]),
          _vm._v(" "),
          _c("b", [
            _vm.ruolo_da_chiamare == _vm.Constants.RUOLO_DA_CHIAMARE.QUALUNQUE
              ? _c("span", [_vm._v("QUALUNQUE RUOLO")])
              : _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.Constants.RUOLI_NEW[_vm.ruolo_da_chiamare].plurale
                    )
                  ),
                ]),
          ]),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: {
                outlined: "",
                depressed: "",
                "x-small": "",
                rounded: "",
                icon: "",
              },
              on: { click: _vm.promptImpostazioni },
            },
            [_c("v-icon", { attrs: { "x-small": "" } }, [_vm._v("edit")])],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }